import dayjs from 'dayjs';
import 'dayjs/locale/de';
import React from 'react';
import './WeekItem.scss';
import { useTranslation } from 'react-i18next';

export interface Props {
  className?: string;
  isActive?: boolean;
  onClick?: () => void;
  startDate: Date;
  weekNumber: number;
}

const WeekItem: React.FC<Props> = (props) => {
  const scope = 'WeekItem';

  const { t } = useTranslation();

  const className = [
    scope,
    props.isActive && `${scope}--active`,
    props.className,
  ]
    .filter((className) => className)
    .join(' ');

  const dayJsObject = dayjs(props.startDate).locale('de');
  const dateString = dayJsObject.format('DD MMM');
  const weekNumberString = `${props.weekNumber}`.padStart(2, '0');
  const nameString = `${t('week')} ${weekNumberString}`;

  return (
    <div className={className} onClick={props.onClick}>
      <div className={`${scope}-date`}>{dateString}</div>
      <div className={`${scope}-name`}>{nameString}</div>
    </div>
  );
};

export default WeekItem;
